<template>
  <div class="card">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <h3 class="card-title mb-0">Carrito de compras</h3>
        <div v-if="cartp.length && merchandiseBO">
          <form v-if="!coupon.code" @submit.prevent="verifyCoupon()">
            <input v-model="couponCode" type="text" class="form-control" :class="{ 'is-invalid': couponError }"
              placeholder="Código de cupón" />
          </form>
          <span v-else class="btn btn-primary">
            {{ discountText }}
            <button @click="removeCoupon()" class="close ml-3">&times;</button>
          </span>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div v-if="!cartp.length">
        <h5>Tu carrito esta vacío</h5>
        <div>Agrega entradas a tu carrito.</div>
      </div>
      <div v-else>
        <div v-for="item in cartp" :key="item.adhId" class="card shadow-sm bg-light mb-3">
          <div class="row no-gutters">
            <div class="col-auto" v-if="item.imageUrl">
              <img :src="item.imageUrl" width="160" alt="img" />
            </div>
            <div class="col">
              <div class="card-body py-2">
                <button @click="removeItemByHour(item)" type="button" class="close">&times;</button>
                <h5 class="mb-1">
                  <b>{{ item.title }}</b>
                </h5>
                <div class="mb-1">
                  <b>Fecha: </b>
                  <span> {{ dateFriend(item.day) }} - {{ hourFriend(item.hour) }} </span>
                </div>
                <div class="mb-2">
                  <b>Tickets: </b>
                  <span v-for="type in item.types" :key="type.ticketTypeId"
                    class="btn btn-outline-secondary btn-sm py-0 ml-2">
                    <span><b>{{ type.value }}</b> - {{ type.name }}</span>
                    <button @click="removeItemByType(type)" class="close ml-2">&times;</button>
                  </span>
                </div>
                <div class="row" v-if="showCouponByEvent">
                  <div class="col">
                    <Coupon :item="item" @availablesCuopons="setCuopons" />
                  </div>
                  <div class="col">
                    <PayByEvent :tickets="item" :currency="currency" :validatedCuopons="setValidatedCuopons"
                      @totalsByEvent="totalsByEvent" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api';

export default {
  props: ['currency'],

  data() {
    return {
      coupon: '',
      couponCode: '',
      couponError: false,
      discount: 0,
      setValidatedCuopons: [],
      showCouponByEvent: true
    };
  },
  watch: {
    coupon(value) {
      this.showCouponByEvent = value ? false : true;
    },
  },
  computed: {
    cart() {
      return this.$store.state.cart.cartEvents;
    },
    cartp() {
      return this.getCartEvents(this.cart);
    },
    discountText() {
      let txt = '';
      const { name, value } = this.coupon;
      if (name === 'percentage') {
        txt = `Descuento de ${value}%`;
      } else {
        txt = `Descuento de ${this.currency} ${value}`;
      }
      return txt;
    },
    merchandiseBO() {
      return this.$store.state.event.merchandiseBO === 1 ? true : false;
    },
  },
  methods: {
    setCuopons(value, ticket) {
      if (value.length) {
        this.setValidatedCuopons = value
        const cupon = value[0];
        const data = {
          code: cupon.code,
          name: "percentage",
          type: cupon.type,
          value: cupon.discountValue
        }
        this.$emit('apply-coupon', data, ticket);
      } else {
        this.$emit('apply-coupon', '', ticket);
      }
    },
    totalsByEvent(value) {
      this.$emit('totalsByEvent', value);
    },
    async verifyCoupon() {
      this.couponError = false;
      this.coupon = {};
      const { data } = await api.axios(`/coupon?code=${this.couponCode}`);
      if (data.status) {
        this.coupon = data.data;
        this.$emit('apply-coupon', this.coupon);
      } else {
        this.couponError = true;
        setTimeout(() => {
          this.couponError = false;
        }, 7000);
      }
    },

    removeCoupon() {
      this.couponCode = '';
      this.coupon = '';
      this.$emit('apply-coupon', '');
    },
    updateCart(cart) {
      this.$store.commit('updateCartEvents', cart);
    },
    removeItemByType(type) {
      const cartClon = [...this.cart];
      const idx = cartClon.findIndex(
        (el) => el.adhId === type.adhId && el.ticketTypeId === type.ticketTypeId
      );
      cartClon.splice(idx, 1);

      this.updateCart(cartClon);
    },
    removeItemByHour(item) {
      const items = this.cart.filter((el) => el.adhId === item.adhId);
      items.forEach((type) => {
        this.removeItemByType(type);
      });
    }
  }
};
</script>
